import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const TermsPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO title="Terms & Conditions" description="Read the terms and conditions for shopping at Plymhair & Extensions." url="/terms" />
      <Navbar />

      <section className="bg-foreground text-primary-foreground py-24 md:py-32 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-display text-5xl md:text-7xl mb-4">
            Terms & <span className="italic font-normal">Conditions</span>
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 prose prose-neutral dark:prose-invert font-body prose-headings:font-display prose-h2:text-primary prose-h3:text-primary">
          <p>
            This website is owned and operated by Plymhair, registered in England and Wales under registration number 09608450. Our registered office and principal place of business is at:
          </p>
          <p>
            <strong>Plymhair & Extensions</strong><br />
            21 Market Avenue<br />
            Plymouth<br />
            PL1 1PG
          </p>
          <p>Website: <a href="https://www.plymhair.co.uk" className="text-primary">www.plymhair.co.uk</a></p>
          <p>Contact us by writing to the address above, by email, or by telephone on <strong>01752 651631</strong>.</p>

          <h2>1. Terms of Use</h2>
          <p>These terms and conditions govern your use of our website. By using our website, you accept these terms and conditions in full. If you disagree with any part, you must not use our website.</p>
          <p>You must be at least 18 years of age to use our website. Our website uses cookies; by using our website you consent to our use of cookies in accordance with our privacy and cookies policy.</p>

          <h3>1.2 Licence to Use Website</h3>
          <p>You may view, download, and print pages from our website for your own personal purposes. You must not republish, sell, rent, sub-license, show in public, exploit commercially, or redistribute material from our website without our prior written consent.</p>

          <h3>1.3 Acceptable Use</h3>
          <p>You must not use our website in any way that causes damage or impairment of performance; in any unlawful, illegal, fraudulent, or harmful way; to distribute malicious software; or to conduct automated data collection without our express written consent.</p>

          <h3>1.4 Products and Items</h3>
          <p>The advertising of products on our website constitutes an "invitation to treat" rather than a contractual offer. Prices stated may be incorrect — we will verify prices before the contract comes into force. We may periodically change available products.</p>

          <h3>1.5 Registration and Accounts</h3>
          <p>You may register for an account during the checkout process. You must notify us immediately if you become aware of any unauthorised use of your account.</p>

          <h3>1.6 User IDs and Passwords</h3>
          <p>You must keep your password confidential and notify us immediately of any disclosure. You are responsible for any activity arising from failure to keep your password confidential.</p>

          <h3>1.7 Cancellation and Suspension of Account</h3>
          <p>We may suspend, cancel, or edit your account at any time in our sole discretion without notice or explanation.</p>

          <h3>1.10 Limited Warranties</h3>
          <p>We do not warrant the completeness or accuracy of information published, that material is up to date, or that any service will remain available. We reserve the right to discontinue or alter services at any time.</p>

          <h3>1.11 Limitation and Exclusions of Liability</h3>
          <p>Nothing in these terms will limit liability for death or personal injury from negligence, or for fraud. We will not be liable for business losses, data corruption, or special/indirect/consequential loss or damage.</p>

          <h3>1.20 Law and Jurisdiction</h3>
          <p>These terms shall be governed by and construed in accordance with English law. Disputes shall be subject to the exclusive jurisdiction of the courts of England.</p>

          <h2>2. Terms and Conditions of Sale</h2>

          <h3>2.1 Order Process</h3>
          <p>To purchase products: add items to your shopping cart, proceed to checkout, create an account or log in, select delivery method, confirm your order, and pay. We will send an acknowledgement, then either a confirmation and dispatch notification or a notice that we cannot fulfil the order.</p>
          <p>Should you wish to purchase more than three wigs on one order, please call our customer services team on 01752 651631.</p>

          <h3>2.3 Prices</h3>
          <p>Prices are quoted on our website and may change, but changes will not affect existing contracts. We apply standard pricing across the UK and Channel Islands. Delivery charges are additional.</p>

          <h3>2.5 VAT Exemption</h3>
          <p>We are not currently VAT registered and do not collect VAT Exemption applications.</p>

          <h3>2.6 Payments and Charge Backs</h3>
          <p>Payment must be made during checkout using permitted methods. Unjustified charge-backs will incur the charge-back amount, all third-party expenses, a £25.00 administration fee, and all reasonable recovery costs.</p>

          <h3>2.8 Cancellation Rights (Distance Contracts)</h3>
          <p>As a consumer, you may cancel a contract within 14 days after receiving the products. You must inform us of your decision and return the products at your own cost. We will refund the product price (not original delivery charges) within 14 days of receiving the returned items.</p>
          <p>Cancellation rights do not apply to products made to your specification, personalised items, or items unsuitable for return due to hygiene reasons.</p>

          <h3>2.14 Discount Codes</h3>
          <p>Discount codes cannot be used in conjunction with any other offers.</p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;
